module.exports = __webpack_public_path__ + "static/media/simona.564395c5.jpg";